import React, { Component } from "react";
import Credentials, { currentTenant, financialyearend, financialyearstart } from "../../Common/Credentials"
import NewReportService from "../NewReportService"
import moment from "moment";

let fyfrom,fyto,inputindirecttax,dirtaxpaid,subaccdata=[],debit,credit
const debTotal = (debit) => {
    let total=0 ;
    //  console.log(data)
    debit.forEach(debit => {
      total += debit;
    });
    // console.log(total)
    
    return total;
  };
  const creTotal = (credit) => {
    let total=0 ;
    //  console.log(data)
    credit.forEach(credit => {
      total += credit;
    });
    // console.log(total)
    return total;
  };
 const setProfit=(amt)=>{
   
  if(amt!=undefined){
    Credentials.setPlprofit(amt)
  }
    }
const setLoss=(amt)=>{
   if(amt!=undefined){
      Credentials.setPlloss(amt)
   }
    }
  
class PlComponent  {//extends Component
// constructor(props) {
//         super(props);
//         this.state = {
//           debitexcess: 0,
//           creditexcess:0
//         };
//         this.onFySelect=this.onFySelect.bind(this);
//         this.setValues=this.setValues.bind(this);
//       }
   async  onFySelect(value){

        let year
      //  if(value.from!==financialyearstart){
          year={
            from: moment(value.from).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            to: moment(value.to).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            tenantid:currentTenant
              }
              fyfrom =value.from
              fyto=value.to
          //this.setState({fyfrom:value.from,fyto:value.to})
        // }else{
        //   year={
        // from:'Cur',
        // to:'year',
        // tenantid:currentTenant
        //   }
          fyfrom =financialyearstart
          fyto=financialyearend
          //this.setState({fyfrom:financialyearstart,fyto:financialyearend})
    
       // }
  
       let direxp= await NewReportService.getDirtaxPaid(currentTenant)
          dirtaxpaid=direxp.data
        
       let inptax =await  NewReportService.getInputIndirecttax(currentTenant)
          inputindirecttax=inptax.data
    
       
      let plresp = await  NewReportService.retrivePLLedgers(year) 
          subaccdata=plresp.data.sort((a, b)=>{
            if(a.name < b.name) { return -1; }
            if(a.name > b.name) { return 1; }
            return 0;
        })
        //   const script = document.createElement("script");
        //   script.src = "../../js/content.js";
        //   script.async = true;
        //   document.body.appendChild(script);

           debit = subaccdata.map(e => {return (e.th==="TH1"?e.totamount:0)})
          credit = subaccdata.map(e => {return (e.th==="TH2"?e.totamount:0)})

         let  creditexcess = creTotal(credit) > debTotal(debit)? creTotal(credit)-debTotal(debit):0
       let debitexcess= debTotal(debit)> creTotal(credit)?debTotal(debit) - creTotal(credit):0
          setProfit(debitexcess)
          setLoss(creditexcess)

         let val
          
        // this.setValues(debitexcess,creditexcess)

        //  alert( +"  "+)
         val ={
            debitexcess:debitexcess,
            creditexcess:creditexcess
          }

          //this.setState({ loading: false });
      //  })
        //NewJournalService.getAssets(year).then((response) => {
        //   this.setState({ assets: response.data },()=>this.assetsubheads())
        //   this.setState({ loading: false });
        // })
        // NewJournalService.getLiabilities(year).then((response) => {
        //   this.setState({ liabilities: response.data },()=>this.liabsubheads())
        //   this.setState({ loading: false });
        // })
return val
      }
  
      // setValues(debitexcess,creditexcess){
      //    this.setState({debitexcess:debitexcess,creditexcess:creditexcess})
      // }
      
      fyyears(){
        // let fyyears=[]
        //let def={from:'Current',to:'year'}
        let def={from:financialyearstart,to:financialyearend}
  
    //  this.setState({ 
    //    fylist: this.state.fylist.concat(def)
    //  }) 

}

calculateLedgerExpences(totalamt,name){
    let a
        Object.entries(totalamt).forEach(([key, value]) => {
          if(key === name){
           a = {
            name: key,
            expenses: value.reduce((a, v) => 
            (a = a +(v.totamount === null? 0 : ((v.rule===(0||1) && v.entrytype===0 && v.name === name)?(v.rule===2  && v.entrytype===1 && v.name === name)?v.totamount:v.totamount:0))
            ), 0),
            // income: value.reduce((a, v) => 
            // (a = a +(v.totamount === null? 0 : ((v.rule===0,1 && v.entrytype===1 && v.name === name) ?(v.rule===2  && v.entrytype===0 && v.name === name )?v.totamount:v.totamount:0))
            // ), 0),
          };
        }
        });
        return a.expenses === 0?null: a.expenses
  }
  calculateLedgerIncome(totalamt,name){
    let a
        Object.entries(totalamt).forEach(([key, value]) => {
          if(key === name){
           a = {
            name: key,
            // expenses: value.reduce((a, v) => 
            // (a = a +(v.totamount === null? 0 : ((v.rule===0,1 && v.entrytype===0 && v.name === name)?(v.rule===2  && v.entrytype===1 && v.name === name)?v.totamount:v.totamount:0))
            // ), 0),
            income: value.reduce((a, v) => 
            (a = a +(v.totamount === null? 0 : ((v.rule===(0||1) && v.entrytype===1 && v.name === name) ?(v.rule===2  && v.entrytype===0 && v.name === name )?v.totamount:v.totamount:0))
            ), 0),
          };
        }
        });
        return a.income === 0 ?null:a.income
  }
 calcSubTotal(name1){
  cre1=subaccdata.map((e) => { return e.th==="TH2" && e.name===name1 ? e.totamount:0})
  deb1=subaccdata.map((e) => { return e.th==="TH1" && e.name===name1 ? e.totamount:0})

}

//  render() {
//         return (
//            this.state.debitexcess,
//             this.state.debitexcess
//         );
//       }

}
export default  new PlComponent();